module.exports = __webpack_public_path__ + "img/wiperx_feature_01.da5444ca.jpg";